import { render, staticRenderFns } from "./curveCollect.vue?vue&type=template&id=ce06d9c8&scoped=true"
import script from "./curveCollect.vue?vue&type=script&lang=js"
export * from "./curveCollect.vue?vue&type=script&lang=js"
import style0 from "./curveCollect.vue?vue&type=style&index=0&id=ce06d9c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce06d9c8",
  null
  
)

export default component.exports